var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _circle2, _rect6, _circle3, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntityIdentification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 187,
    viewBox: "0 0 237 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236.333,
    height: 187,
    rx: 16,
    fill: "#EFEBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 188.333,
    height: 139,
    rx: 16.3778,
    fill: "#DED6FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3828,
    y: 52.2625,
    width: 156.233,
    height: 36.805,
    rx: 6.00898,
    fill: "#C5B3FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7854,
    cy: 70.665,
    r: 8.63791,
    fill: "#9272FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4365,
    y: 65.4072,
    width: 106.659,
    height: 10.5157,
    rx: 3.00449,
    fill: "#A78EFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3828,
    y: 97.0674,
    width: 156.233,
    height: 36.805,
    rx: 6.00898,
    fill: "#E9E3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7854,
    cy: 115.47,
    r: 8.63791,
    fill: "#A78EFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4365,
    y: 110.212,
    width: 106.659,
    height: 10.5157,
    rx: 3.00449,
    fill: "#B6A0FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.509,
    cy: 100.26,
    r: 21.6638,
    fill: "#6D42FF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.564 117.134L195.232 129.802L191.049 133.985L178.381 121.317C173.826 124.961 168.05 127.141 161.767 127.141C147.072 127.141 135.146 115.214 135.146 100.519C135.146 85.8242 147.072 73.8977 161.767 73.8977C176.462 73.8977 188.389 85.8242 188.389 100.519C188.389 106.802 186.209 112.579 182.564 117.134ZM176.63 114.939C180.247 111.211 182.473 106.126 182.473 100.519C182.473 89.0794 173.207 79.8136 161.767 79.8136C150.327 79.8136 141.061 89.0794 141.061 100.519C141.061 111.959 150.327 121.225 161.767 121.225C167.374 121.225 172.459 118.999 176.187 115.382L176.63 114.939Z",
    fill: "#2C1A66"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_775_1706",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 73,
    width: 61,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.564 117.131L195.232 129.799L191.049 133.982L178.381 121.314C173.826 124.958 168.05 127.138 161.767 127.138C147.072 127.138 135.146 115.212 135.146 100.517C135.146 85.8215 147.072 73.895 161.767 73.895C176.462 73.895 188.389 85.8215 188.389 100.517C188.389 106.799 186.209 112.576 182.564 117.131ZM176.63 114.936C180.247 111.208 182.473 106.124 182.473 100.517C182.473 89.0767 173.207 79.8109 161.767 79.8109C150.327 79.8109 141.061 89.0767 141.061 100.517C141.061 111.956 150.327 121.222 161.767 121.222C167.374 121.222 172.459 118.996 176.187 115.379L176.63 114.936Z",
    fill: "#2C1A66"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_775_1706)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.694,
    y: 128.842,
    width: 9.28448,
    height: 7.95812,
    transform: "rotate(-45 183.694 128.842)",
    fill: "#9272FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.503,
    y: 122.647,
    width: 9.28448,
    height: 7.95812,
    transform: "rotate(-45 177.503 122.647)",
    fill: "#9272FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.09 86.0466C172.629 86.5974 172.294 87.0978 171.849 87.6419C171.685 87.8421 171.715 88.1419 171.926 88.2925C174.124 89.8668 175.452 90.2224 178.237 93.7813C178.5 94.1178 179.022 93.9373 178.968 93.5135C178.525 90.0753 176.408 87.3634 173.602 85.9413C173.427 85.8529 173.216 85.8968 173.09 86.0466Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityIdentification);
export default __webpack_public_path__ + "static/media/entity-identification.68d7e9d44e9a97960dba89b193b0bd9b.svg";
export { ForwardRef as ReactComponent };